import { Command } from 'commander';
import { GeneratePullerCommand } from './generatePullerCommand';
import { StepCommands } from '../StepCommands';

export function PullerCommand(): Command {
  const cmd = new Command('puller');
  cmd.alias('pl').description('Puller related commands.');

  cmd.addCommand(GeneratePullerCommand());
  cmd.addCommand(StepCommands('puller'));
  return cmd;
}
